import React from "react";
import OnlyInvoieToPrint from "./onlyInvoiceToPrint";

import ReactToPrint from "react-to-print";

class PrintableInvoice extends React.PureComponent {
  render() {
    return (
      <div>
        <OnlyInvoieToPrint />
      </div>
    );
  }
}

class Print extends React.PureComponent {
  render() {
    return (
      <div>
        <div className="zp-inv-toolbar">
          <ReactToPrint
            trigger={() => {
              return (
                <button className="zp-inv-print-btn" href="#">
                  <i className="icofont-printer" />
                  &nbsp;Print Invoice
                </button>
              );
            }}
            content={() => this.componentRef}
          />
        </div>
        <PrintableInvoice
          ref={(el) => (this.componentRef = el)}
          orderObj={this.props.orderObj}
        />
      </div>
    );
  }
}

export default Print;
